import m from "../../geodata/es2015/philippinesHigh";
window.am4geodata_philippinesHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/philippinesHigh.js
// module id = null
// module chunks = 